/*
  Y2K Fake-3D tilt (CLAUDE.md §6) — [data-tilt] olan her elemanda.
  - YALNIZ gerçek hover'lı hassas işaretçide (fare/trackpad) kurulur — CSS
    hover kapılarıyla ve y2k-rail.js ile aynı sorgu. Dokunmatikte (hover: none
    / pointer: coarse) ve prefers-reduced-motion'da tamamen kapalı. 42.1: karma
    cihazlarda (dokunmatik ekranlı dizüstü, kalem) parmak/kalem hareketi kartı
    eğmez — yalnız pointerType 'mouse'.
  - Event delegation: dinamik eklenen kartlar (PLP facet yenilemesi, tema
    editörü section reload, öneri yüklemeleri) ekstra tarama GEREKTİRMEZ —
    pointermove document'ta yakalanır, en yakın [data-tilt] bulunur.
  - Davranış §6 ile birebir: rotateY x*10, rotateX y*-8, perspective 800px;
    ayrılınca transform sıfırlanır (CSS'teki transition yumuşatır).
*/
(function () {
  'use strict';

  if (window.__y2kTiltInit) return;
  window.__y2kTiltInit = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (REDUCE || !FINE) return;

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var card = e.target && e.target.closest ? e.target.closest('[data-tilt]') : null;
    if (!card) return;
    if (!card.dataset.tiltReady) {
      card.dataset.tiltReady = '1';
      card.style.transformStyle = 'preserve-3d';
    }
    var r = card.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width - 0.5;
    var y = (e.clientY - r.top) / r.height - 0.5;
    card.style.transform =
      'perspective(800px) rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (y * -8).toFixed(2) + 'deg)';
  });

  document.addEventListener('pointerout', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-tilt]') : null;
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return; // hâlâ kart içinde
    card.style.transform = '';
  });
})();
